import { __assign, __read, __rest } from "tslib";
import React, { useState } from "react";
import { Box, ClickAwayListener, FormControlLabel, Radio, RadioGroup, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import FilterIcon from "../../../assets/icons/Icon_filter.svg";
import FilterIconActive from "../../../assets/icons/Icon_filter_active.svg";
import ChevronDownSvg from "../../../assets/icons/icon-chevron-down.svg";
import ChevronUpSvg from "../../../assets/icons/icon-chevron-up.svg";
var DropFilter = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange, rest = __rest(_a, ["options", "value", "onChange"]);
    var classes = useStyles();
    var _b = __read(useState(false), 2), viewFilterWrapper = _b[0], setViewFilterWrapper = _b[1];
    var handleClickAway = function () {
        setViewFilterWrapper(false);
    };
    return (React.createElement(ClickAwayListener, { onClickAway: handleClickAway },
        React.createElement(Box, __assign({ style: { position: "relative" } }, rest),
            React.createElement(Box, { className: classes.filterContainer, onClick: function () { return setViewFilterWrapper(function (s) { return !s; }); } },
                React.createElement("img", { src: viewFilterWrapper ? FilterIconActive : FilterIcon, alt: "filter icon", className: classes.columnFilterIcon }),
                React.createElement(Typography, { className: classes.filterTitleText }, "Filters"),
                React.createElement("img", { src: viewFilterWrapper ? ChevronUpSvg : ChevronDownSvg, alt: "filter icon", className: classes.columnFilterIcon })),
            viewFilterWrapper && (React.createElement(Box, { className: classes.filbersBlock },
                React.createElement(RadioGroup, { row: true, value: "".concat(value), style: { color: "primary" }, onChange: function (e) {
                        onChange(e.target.value);
                        setViewFilterWrapper(false);
                    } }, options.map(function (item) { return (React.createElement(FormControlLabel, { key: "".concat(item.value), value: "".concat(item.value), control: React.createElement(Radio, { color: "primary" }), label: React.createElement(Typography, { className: classes.labelText }, item.label) })); })))))));
};
export default DropFilter;
//# sourceMappingURL=DropFilter.js.map